import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-secondary-200 md:border-r-2 md:py-3 md:pr-2" }
const _hoisted_2 = { class: "flex-1 text-center md:text-left" }
const _hoisted_3 = { class: "font-semibold" }

import { useI18n } from 'vue-i18n'

interface Props {
  /** The card header text */
  cardHeader: string
  /** The informational text */
  infoText: string
  /** The download link URL */
  link: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'DocumentLinkCard'
},
  __name: 'DocumentLinkCard',
  props: {
    cardHeader: {},
    infoText: {},
    link: {}
  },
  setup(__props: any) {





const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_VCardText = _resolveComponent("VCardText")!
  const _component_VCard = _resolveComponent("VCard")!

  return (_openBlock(), _createBlock(_component_VCard, { class: "class shadow-card outline-2 outline-secondary-200" }, {
    default: _withCtx(() => [
      _createVNode(_component_VCardText, { class: "flex flex-col flex-wrap items-center gap-content md:flex-row" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_VIcon, {
              icon: "$file-outline",
              size: "x-large",
              class: "text-primary"
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.cardHeader), 1),
            _createElementVNode("p", null, _toDisplayString(__props.infoText), 1)
          ]),
          _createVNode(_component_PrimaryButton, {
            class: "min-w-32",
            href: __props.link,
            download: "",
            text: _unref(t)('general.download')
          }, null, 8, ["href", "text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})